import { useNavigate, /* useLocation */ } from 'react-router-dom'
import { useNavigation } from 'contexts/NavigationContext'
import { useEffect, useState } from 'react'
// import Button from 'components/Button'
import './index.scss'
import LanguageSelect from './LanguageSelect'
// import LanguageSelect from './LanguageSelect'

interface TopbarProps {
  theme: string
  isSticky: boolean
  title?: string
  isLanguage?: boolean
}

const TopBar: React.FC<TopbarProps> = ({ theme, isSticky, title, isLanguage }) => {
  const navigate = useNavigate()
  // const location = useLocation()
  const { toggleNavigationMobile } = useNavigation()
  const [/* windowWidth */, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      <div className={`topbar topbar--mobile ${isSticky ? 'sticky' : ''} ${theme}`}>
        <div className="topbar__wrap">
          {title ? (
            <>
              <i className='icon icon--back' onClick={() => navigate(-1)}></i>
              <span>{title}</span>
            </>
          ) : (
            <div className="topbar__logo">
              <h1 onClick={() => navigate('/')}>Moje Kondolencje</h1>
            </div>
          )}
          {isLanguage && <LanguageSelect />}
          <i
            className={`icon icon--menu`}
            onClick={toggleNavigationMobile}
          ></i>
        </div>
      </div>
      {/* <div className='topbar'>
           <div className="topbar__wrap">
             <div className="topbar__logo --desktop">
               <h1 onClick={() => navigate('/')}>Moje Kondolencje</h1>
             </div>
             <div className="topbar__buttons">
               <div className="wrap">
                 <span onClick={() => navigate('/')} className={`${location.pathname === '/' ? 'active' : ''}`}>Pulpit</span>
                 <span onClick={() => navigate('/map')} className={`${location.pathname === '/map' ? 'active' : ''}`}>Mapa</span>
               </div>
             </div>
             <div className="topbar__buy">
               <div className="wrap"><i className='icon icon--user-box'></i></div>
               <Button type='primary' text='Dodaj pomnik' icon='add' action={() => navigate('/addprofile')} />
             </div>
           </div>
         </div> */}
    </>
  )
}

export default TopBar